<div class="filters-bar">
	<mat-card class="mt-0" id="tag-dropzone-filter" cdkDropList (cdkDropListDropped)="tagsDropAssign.drop($event)">
		<mat-card-content class="p-0">
			<div class="d-flex flex-wrap align-items-center justify-contents-start mx-1">
				<form #filtersFormDirective="ngForm" [formGroup]="filtersFormGroup" class="mt-2 flex-fill d-flex flex-wrap" (submit)="filterListItems()">
					<mat-form-field class="ms-1" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label>{{ 'TRANSCRIPTIONS.TYPE' | translate }}</mat-label>
						<select id="types" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select id="transcriptionTypes" formControlName="types" multiple>
							<mat-option #selectAllTranscriptionTypes value="ALL" (click)="transcriptionTypeSelection()">{{ 'TRANSCRIPTIONS.TYPES.ALL' | translate }}</mat-option>

							@for (transcriptionType of transcriptionTypes; track $index) {
							<mat-option [value]="transcriptionType.id" (click)="transcriptionTypeSelection($event)">{{ 'TRANSCRIPTIONS.TYPES.' + transcriptionType.id | translate }}</mat-option>
							}
						</mat-select>
					</mat-form-field>

					<mat-form-field class="ms-1" style="max-width: 120px;">
						<mat-label>{{ 'TRANSCRIPTIONS.LANG' | translate }}</mat-label>
						<select id="langs" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select id="transcriptionLangs" formControlName="langs" multiple>
							@for (transcriptionLang of transcriptionLangs; track transcriptionLang.id) {
								<mat-option [value]="transcriptionLang.id">
									{{ 'TRANSCRIPTIONS.LANGS.' + transcriptionLang.id | translate }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>

					<mat-form-field class="ms-1" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-date-range-input [rangePicker]="picker" color="primary" [max]="DATE_RANGE_LIMITS.dateTo">
							<input id="dateFrom" formControlName="createdAtFrom" matStartDate placeholder="{{ 'TRANSCRIPTIONS.DATE_FROM' | translate }}" />
							<input id="dateTo" formControlName="createdAtTo" matEndDate placeholder="{{ 'TRANSCRIPTIONS.DATE_TO' | translate }}" [value]="getDateLimitRange()" />
						</mat-date-range-input>
						<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-date-range-picker #picker>
							<mat-date-range-picker-actions>
								<button mat-button matDateRangePickerCancel>{{ 'BUTTON.CANCEL' | translate }}</button>
								<button mat-raised-button color="primary" matDateRangePickerApply>{{ 'BUTTON.APPLY' | translate }}</button>
							</mat-date-range-picker-actions>
						</mat-date-range-picker>
					</mat-form-field>

					<mat-form-field class="ms-1 flex-fill">
						<mat-label>{{ 'BUTTON.SEARCH' | translate }}</mat-label>
						<input matInput formControlName="text" placeholder="" />
						<mat-icon
							matSuffix
							#searchHelpTooltip="matTooltip"
							class="search-help-icon"
							matTooltipClass="wide-tooltip"
							matTooltipPosition="above"
							[matTooltip]="'TRANSCRIPTIONS.SEARCH_HELP_TEXT' | translate"
							(click)="searchHelpTooltip.toggle()">info_outline</mat-icon>
					</mat-form-field>

					<!-- File name filter removed for admins; the main search covers it.
					<mat-form-field class="ms-1" style="max-width: 140px;">
						<mat-label>{{ 'TRANSCRIPTIONS.FILE_NAME' | translate }}</mat-label>
						<input matInput formControlName="fileName" placeholder="" />
					</mat-form-field>
					-->

					<mat-form-field class="ms-1" style="max-width: 120px;">
						<mat-label>{{ 'TRANSCRIPTIONS.SPEAKER' | translate }}</mat-label>
						<input matInput formControlName="speaker" placeholder="" />
					</mat-form-field>

					@if (role === 'admin') {
					<mat-form-field class="ms-1" style="max-width: 150px;">
						<mat-label for="clientId">{{ 'TRANSCRIPTIONS.CLIENTS' | translate }}</mat-label>
						<input type="text" matInput formControlName="clientId" [matAutocomplete]="clientAutocomplete" (click)="filtersFormGroup.controls['clientId'].setValue(null)" />
						<mat-autocomplete #clientAutocomplete="matAutocomplete" [displayWith]="displayClientFn.bind(this)">
							@for (filteredItem of filteredClients; track $index) {
							<mat-option [value]="filteredItem">{{ filteredItem.name }}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
					}

					<div class="ms-1 d-flex mb-1">
						<button
							type="button"
							mat-raised-button
							color="primary"
							class="me-1"
							aria-label="Reset form button"
							matTooltip="{{ 'TRANSCRIPTIONS.RESET_FORM' | translate }}"
							matTooltipPosition="below"
							(click)="resetForm(filtersFormDirective)">
							<mat-icon class="m-0">restart_alt</mat-icon>
						</button>

						<button type="submit" mat-raised-button [color]="filtersActive ? 'warn' : 'primary'" class="me-1" aria-label="Filter button" [disabled]="apiLoading">
							@if(apiLoading) {
							<mat-spinner diameter="20"></mat-spinner>
							} @else {
							<span>{{ 'BUTTON.SHOW' | translate }}</span>
							}
						</button>
					</div>
				</form>
			</div>
			<mat-divider class="w-100"></mat-divider>
		</mat-card-content>
	</mat-card>
</div>